import axios from "../../../../utils/request"
//获取列表内容接口
function GET_LIST(params) {
    return axios.get("/translation/BatchTranslationOther/videoList", {
        params: {
            ...params
        }
    } )
}
//分类翻译信息
function TRANSLATE_CHECK(params) {
    return  axios.post("/translation/BatchTranslationOther/videoTranslateInfo",
        {...params}
    )
}
//日志列表
function PRODUCT_LOG_LIST(params) {
    return axios.get("/translation/BatchTranslationOther/videoLogList", {
        params: {
            ...params
        }
    } )
}
//批量翻译提交
function TRANSLATE(params) {
    return  axios.post("/translation/BatchTranslationOther/videoPost",
        {...params}
    )
}
function GET_NAME(params) {
    return axios.get("/translation/BatchTranslation/customerList", {
        params: {
            ...params
        }
    } )
}

function GET_CLASS(params) {
    return axios.get("/translation/BatchTranslation/productCategoryList", {
        params: {
            ...params
        }
    } )
}


function TRANSLATEPRODUCT(params) {
    return  axios.post("/translation/BatchTranslation/translateProduct",
        {...params}
    )
}


function EDIT_DATA(params) {
    return  axios.post("/help/AHelpVideo/edit",
      {id:params}
      )
}
function SUBMIT_ADD(params) {
    return  axios.post("/help/AHelpVideo/addPost",{...params} )
}

function LIST_ORDER (params) {
    return  axios.post("/help/AHelpVideo/listOrder",{list_orders:params} )
}

function RETRY_TRANSLATE_CHECK (params) {
    return  axios.post("/translation/BatchTranslationOther/retryTranslatePost",{...params} )
}

function RETRY_TRANSLATE_PRODUCT (params) {
    return  axios.post("/translation/BatchTranslation/retryTranslatePost",{...params} )
}

function GET_CUSTOMER_INFO(params) {
    return  axios.get("/translation/BatchTranslation/customerInfo",{
        params: {
            ...params
        }
    } )
}

function SUBMIT_EDIT(params) {
    return  axios.post("/help/AHelpVideo/editPost",{...params} )
}

function CHANG_STATUS (params) {
    return  axios.post("/help/AHelpVideo/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/help/AHelpVideo/delete",{
        params: {
            ids:params
        }
    } )
}
export default {
    GET_LIST,
    // ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
    LIST_ORDER,
    GET_NAME,
    GET_CLASS,
    TRANSLATE_CHECK,
    TRANSLATE,
    TRANSLATEPRODUCT,
    PRODUCT_LOG_LIST,
    RETRY_TRANSLATE_CHECK,RETRY_TRANSLATE_PRODUCT
,GET_CUSTOMER_INFO
}
